import { format } from 'date-fns';
import { FC } from 'react';

import { CompactLectureCardDisabled } from '@/components/event/CompactLectureCardDisabled';
import { CompactLectureCardEnabled } from '@/components/event/CompactLectureCardEnabled';
import { useUserEventTimezone } from '@/hooks/useUserEventTimezone';
import { timezonesList } from '@/lib/time-zones';
import { ThinEventSession } from '@/resources/ThinEventSession';
import { ThinLecture } from '@/resources/ThinLecture';
import { isEnabled } from '@/utils/models/lecture';

interface ICompactLectureCard {
  lecture: ThinLecture;
  eventId: string;
  eventSession: ThinEventSession;
}

export const CompactLectureCard: FC<ICompactLectureCard> = ({ lecture, eventId, eventSession }) => {
  const userEventTimezone = useUserEventTimezone(eventId);

  const duration = (date: string | number | Date) => {
    const localStorageTimezone = timezonesList.find((tz) => tz === userEventTimezone);
    const timeZone = localStorageTimezone || Intl.DateTimeFormat().resolvedOptions().timeZone;

    return format(new Date(new Date(date).toLocaleString('en-US', { timeZone })), 'dd MMM, HH:mm');
  };

  const time = duration(lecture.heldAt);

  const url = lecture.posterLecture
    ? `/events/${eventId}/posters/${eventSession.id}/poster/${lecture.linkSlug}`
    : `/events/${eventId}/sessions/${eventSession.id}/lecture/${lecture.linkSlug}`;

  const enabled = isEnabled(lecture);

  if (enabled) return <CompactLectureCardEnabled time={time} url={url} lecture={lecture} />;

  return <CompactLectureCardDisabled lecture={lecture} time={time} />;
};
